// 고객센터 전화 연결 가능 여부.
// 표시 문구(평일 10:00~17:30 · 점심 13:00~14:00)에 앞뒤 15분 여유를 둔 구간으로,
// 앱의 isOfficeHour() 와 같은 기준이다 — 웹과 앱이 다르게 판정하면 안 된다.
export function isServiceCenterOpen(date: Date): boolean {
  const day = date.getDay()
  if (day === 0 || day === 6) return false

  const minutes = date.getHours() * 60 + date.getMinutes()
  const inRange = (fromH: number, fromM: number, toH: number, toM: number) =>
    minutes >= fromH * 60 + fromM && minutes <= toH * 60 + toM

  return inRange(10, 0, 13, 15) || inRange(14, 15, 17, 45)
}
